import { EngagementAction } from "@models/engagementAction";

export type ActionCtaState =
  | { kind: "approve" }
  | { kind: "review-info" }
  | { kind: "rebrand-info" }
  | { kind: "none" };

export function computeActionCtaState(
  action: EngagementAction | null,
  userRoles: string[]
): ActionCtaState {
  if (!action || !action.is_active) return { kind: "none" };
  const intersects = action.assigned_roles.some((r) => userRoles.includes(r));
  if (!intersects) return { kind: "none" };

  switch (action.type) {
    case "APPROVE":
      return { kind: "approve" };
    case "REVIEW":
      return { kind: "review-info" };
    case "REBRAND":
      return { kind: "rebrand-info" };
    default:
      return { kind: "none" };
  }
}
